import React from "react";

const teamContent = [
  {
    delayAnimation: "0",
    img: "lukian.jpg",
    title: "Lukian Markl",
    designation: "Founder",
  },
  {
    delayAnimation: "100",
    img: "Dome.jpg",
    title: "Dominik Süßmilch",
    designation: "Founder",
  },
];

const Team = () => {
  return (
    <>
      {teamContent.map((val, i) => (
        <div
          className="ptf-animated-block"
          data-aos="fade"
          data-aos-delay={val.delayAnimation}
          key={i}
        >
          {/* <!--Team Member--> */}
          <div className="ptf-team-member ptf-team-member--has-effect">
            <div className="ptf-team-member__avatar">
              <div className="shadow-effect"></div>
              <a>
                {" "}
                <img
                  src={`assets/img/root/team/${val.img}`}
                  alt={val.title}
                  loading="lazy"
                />
              </a>
            </div>
            <div className="ptf-team-member__content">
              <h6 className="ptf-team-member__name">
                <a>{val.title}</a>
              </h6>
              <p className="ptf-team-member__function">{val.designation}</p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default Team;
